import { render, staticRenderFns } from "./ClientSubApprovals.vue?vue&type=template&id=42720560"
import script from "./ClientSubApprovals.vue?vue&type=script&lang=js"
export * from "./ClientSubApprovals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports